<template>
  <div id="join">
    <loading-overlay v-if="loading"></loading-overlay>
    <div class="search">
      <el-input
        placeholder="请输入原告或被告或顾问"
        prefix-icon="el-icon-search"
        v-model.trim="formMore.name"
        clearable
      ></el-input>
      <el-button type="warning" size="mini" @click="ctsearch()">搜索</el-button>
    </div>

    <!-- *****************案件冲突************** -->
    <div class="top">
      <div class="icon"></div>
      <div>
        案件冲突<span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方,灰色背景是导入数据)</span
        >
      </div>
    </div>
    <el-table
      :data="casetableData"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%"
      :row-class-name="tableRowClass"
    >
      <el-table-column prop="code" label="案件编号"></el-table-column>
      <el-table-column prop="title" label="案件名称"></el-table-column>
      <el-table-column prop="litigant" label="当事人">
        <template slot-scope="scope">
          <div v-for="(c,index) in scope.row.litigant " class="litigant-container">
                {{ c.attribute }}：
                <span
                  v-for="(item, index) in c.all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < c.all.length - 1"
                    >,
                  </span>
                </span>
              </div>
          <!-- <div v-if="scope.row.litigant[0]" class="litigant-container">
            {{ scope.row.litigant[0].attribute }}：
            <span
              v-for="(item, index) in scope.row.litigant[0].all"
              :key="item.id"
              style="display: inline"
            >
              <span v-if="item.isshow" style="color: red; font-weight: 900"
                >!</span
              >
              <span
                :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                >{{ item.name }}</span
              >
              <span v-if="index < scope.row.litigant[0].all.length - 1"
                >,
              </span>
            </span>
          </div>

          <div v-if="scope.row.litigant[1]" class="litigant-container">
            {{ scope.row.litigant[1].attribute }}：
            <span
              v-for="(item, index) in scope.row.litigant[1].all"
              :key="item.id"
              style="display: inline"
            >
              <span v-if="item.isshow" style="color: red; font-weight: 900"
                >!</span
              >
              <span
                :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                >{{ item.name }}</span
              >
              <span v-if="index < scope.row.litigant[1].all.length - 1"
                >,
              </span>
            </span>
          </div>
          <div v-if="scope.row.litigant[2]" class="litigant-container">
            {{ scope.row.litigant[2].attribute }}：
            <span
              v-for="(item, index) in scope.row.litigant[2].all"
              :key="item.id"
              style="display: inline"
            >
              <span v-if="item.isshow" style="color: red; font-weight: 900"
                >!</span
              >
              <span
                :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                >{{ item.name }}</span
              >
              <span v-if="index < scope.row.litigant[2].all.length - 1"
                >,
              </span>
            </span>
          </div>
          <div v-if="scope.row.litigant[3]" class="litigant-container">
            {{ scope.row.litigant[3].attribute }}：
            <span
              v-for="(item, index) in scope.row.litigant[3].all"
              :key="item.id"
              style="display: inline"
            >
              <span v-if="item.isshow" style="color: red; font-weight: 900"
                >!</span
              >
              <span
                :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                >{{ item.name }}</span
              >
              <span v-if="index < scope.row.litigant[3].all.length - 1"
                >,
              </span>
            </span>
          </div>
          <div v-if="scope.row.litigant[4]" class="litigant-container">
            {{ scope.row.litigant[4].attribute }}：
            <span
              v-for="(item, index) in scope.row.litigant[4].all"
              :key="item.id"
              style="display: inline"
            >
              <span v-if="item.isshow" style="color: red; font-weight: 900"
                >!</span
              >
              <span
                :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                >{{ item.name }}</span
              >
              <span v-if="index < scope.row.litigant[4].all.length - 1"
                >,
              </span>
            </span>
          </div>
          <div v-if="scope.row.litigant[5]" class="litigant-container">
            {{ scope.row.litigant[5].attribute }}：
            <span
              v-for="(item, index) in scope.row.litigant[5].all"
              :key="item.id"
              style="display: inline"
            >
              <span v-if="item.isshow" style="color: red; font-weight: 900"
                >!</span
              >
              <span
                :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                >{{ item.name }}</span
              >
              <span v-if="index < scope.row.litigant[5].all.length - 1"
                >,
              </span>
            </span>
          </div> -->
        </template>
      </el-table-column>
      <el-table-column label="冲突对象"> 
            <template slot-scope="scope">
              {{ GetNameIdnumber(scope.row.litigant)}}
            </template>
            </el-table-column>
      <el-table-column prop="leadName" label="律师">
        <template slot-scope="scope">
          {{ allLay(scope.row.leadName, scope.row.xlName) }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="litigant[0].all" label="参与方1">
        <template slot-scope="scope" v-if="scope.row.litigant[0]">
          <span
            v-for="(item, index) in scope.row.litigant[0].all"
            :key="item.id"
            style="display: inline"
          >
            <span v-if="item.isshow" style="color: red; font-weight: 900"
              >!</span
            >
            <span :style="{ color: getRandomColor(item.isClient) }">{{
              item.name
            }}</span>
            <span v-if="index < scope.row.litigant[0].all.length - 1">, </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="litigant[1].all" label="参与方2">
        <template slot-scope="scope" v-if="scope.row.litigant[1]">
          <span
            v-for="(item, index) in scope.row.litigant[1].all"
            :key="item.id"
            style="display: inline"
          >
            <span v-if="item.isshow" style="color: red; font-weight: 900"
              >!</span
            >
            <span :style="{ color: getRandomColor(item.isClient) }">{{
              item.name
            }}</span>
            <span v-if="index < scope.row.litigant[1].all.length - 1">, </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="litigant[2].all" label="参与方3">
        <template slot-scope="scope" v-if="scope.row.litigant[2]">
          <span
            v-for="(item, index) in scope.row.litigant[2].all"
            :key="item.id"
            style="display: inline"
          >
            <span v-if="item.isshow" style="color: red; font-weight: 900"
              >!</span
            >
            <span :style="{ color: getRandomColor(item.isClient) }">{{
              item.name
            }}</span>
            <span v-if="index < scope.row.litigant[2].all.length - 1">, </span>
          </span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="entrustmentTime"
        label="办理时间"
        :formatter="formatTime"
      ></el-table-column>
      <!-- <el-table-column
        prop="postTime"
        label="上传时间"
        :formatter="formatTime"
      ></el-table-column> -->
      <el-table-column label="功能" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button
            type="success"
            plain
            size="small"
            @click="Look(scope.row)"
            v-if="conflictCaseDetail&&!scope.row.isOther"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- //分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChangeCase"
        @current-change="handleCurrentChangeCase"
        :current-page="casecurrentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="casepageSize"
        layout="total, sizes"
        :total="caseTotal"
      ></el-pagination>
      <el-pagination
        @size-change="handleSizeChangeCase"
        @current-change="handleCurrentChangeCase"
        :current-page="casecurrentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="casepageSize"
        layout="prev, pager, next, jumper"
        :total="caseTotal"
        v-if="bPageShow"
      ></el-pagination>
    </div>
    <br />
    <br />
    <br />

      <!-- *****************破产管理人************** -->
    <div class="top">
      <div class="icon"></div>
      <div>
        破产管理人冲突<span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方,灰色背景是导入数据)</span
        >
      </div>
    </div>
    <el-table
      :data="bankruptcytableData"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%"
      :row-class-name="tableRowClass"
    >
     <el-table-column prop="name" label="破产企业名称">
        <template slot-scope="scope">
            <span
              style="color: red; font-weight: 900">!</span>
            <span
              style="color: #e86e30;">
              {{ scope.row.name }}
            </span>
          </template>
      </el-table-column>
       <el-table-column prop="code" label="编号" ></el-table-column>
      <el-table-column prop="idnumber" label="身份证号/社会信用代码"></el-table-column>
      <el-table-column prop="soure" label="破产项目来源" >
      </el-table-column>
      <el-table-column prop="lvName" label="代理律师">
          <template slot-scope="scope">
            {{ arrayToString(scope.row.lvName) }}
          </template>
      </el-table-column>
 <el-table-column
        prop="collectionDate"
        label="收案时间"
        width="150"
        :formatter="formatTime"
      >
        </el-table-column>
      
      <el-table-column label="功能" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button
            type="success"
            plain
            size="small"
            @click="Look(scope.row,'bankruptcy')"
            v-if="conflictCaseDetail"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- //分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChangeCase2"
        @current-change="handleCurrentChangeCase2"
        :current-page="casecurrentPage2"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="casepageSize2"
        layout="total, sizes"
        :total="caseTotal2"
      ></el-pagination>
      <el-pagination
        @size-change="handleSizeChangeCase2"
        @current-change="handleCurrentChangeCase2"
        :current-page="casecurrentPage2"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="casepageSize2"
        layout="prev, pager, next, jumper"
        :total="caseTotal2"
        v-if="bPageShow2"
      ></el-pagination>
    </div>
    <br />
    <br />
    <br />
    <!-- *****************顾问冲突************** -->
    <div class="top">
      <div class="icon"></div>
      <div>
        顾问冲突<span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方,灰色背景是导入数据)</span
        >
      </div>
    </div>
    <el-table
      :data="counseltableData"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%"
      :row-class-name="tableRowClass"
    >
      <el-table-column prop="companyName" label="顾问单位">
        <template slot-scope="scope">
            <span
              style="color: red; font-weight: 900">!</span>
            <span
              style="color: #e86e30;">
              {{ scope.row.companyName }}
            </span>
          </template>
      </el-table-column>
      <el-table-column prop="idnumber" label="身份证号/社会信用代码"></el-table-column>
      <el-table-column prop="nikename" label="承办律师"></el-table-column>

      <el-table-column
        prop="endTime"
        label="服务截止时间"
        :formatter="formatTime"
      ></el-table-column>
      <el-table-column prop="isduring" label="是否有效期"></el-table-column>
      <!-- <el-table-column prop="code" label="冲突案件编号"></el-table-column>
      <el-table-column prop="title" label="案件名称"></el-table-column>
      <el-table-column prop="yuangao" label="原告"></el-table-column>
      <el-table-column prop="beigao" label="被告"></el-table-column> -->
      <!-- <el-table-column
        prop="postTime"
        label="案件录入时间"
        :formatter="formatTime"
      ></el-table-column> -->
      <el-table-column label="功能" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button
            type="success"
            plain
            size="small"
            @click="Look(scope.row, 'counsel')"
            v-if="conflictCounselDetail&&!scope.row.isOther"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- //分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChangeCounsel"
        @current-change="handleCurrentChangeCounsel"
        :current-page="counselcurrentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="counselpageSize"
        layout="total, sizes"
        :total="counselTotal"
      ></el-pagination>
      <el-pagination
        @size-change="handleSizeChangeCounsel"
        @current-change="handleCurrentChangeCounsel"
        :current-page="counselcurrentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="counselpageSize"
        layout="prev, pager, next, jumper"
        :total="counselTotal"
        v-if="bPageShow1"
      ></el-pagination>
    </div>
  </div>
</template>
  
  <script>
import { ConflictList, ConflictCounselList,BankruptcyConflictList } from '../../api/conflicts.js'
export default {
  name: 'conflictCase',
  // mixins: [],
  data() {
    return {
      bPageShow: true,
      bPageShow1: true,
      bPageShow2:true,
      formMore: {
        name: ''
      },

      // 案件冲突
      conflictCaseDetail: false,
      casecurrentPage: 1,
      casepageSize: 10,
      caseTotal: 0,
      casetableData: [],

      // 顾问冲突
      conflictCounselDetail: false,
      counselcurrentPage: 1,
      counselpageSize: 10,
      counselTotal: 0,
      counseltableData: [],
      loading: false,

      //破产管理人 有案件冲突的权限就默认有破产管理人的权限
      bankruptcytableData:[],
      casecurrentPage2: 1,
      casepageSize2: 10,
      caseTotal2: 0,
    }
  },
  mounted() {
    this.casecurrentPage = this.$store.state.page
    this.bPageShow = false
    this.$nextTick(() => {
      this.bPageShow = true
    })
    this.counselcurrentPage = this.$store.state.page1
    this.bPageShow1 = false
    this.$nextTick(() => {
      this.bPageShow1 = true
    })
    this.conflictCaseDetail =
      this.$store.state.rolesname.includes('conflictCaseDetail')

    this.conflictCounselDetail = this.$store.state.rolesname.includes(
      'conflictCounselDetail'
    )

    this.casecurrentPage2 = this.$store.state.page2
    this.bPageShow2 = false
    this.$nextTick(() => {
      this.bPageShow2 = true
    })
    console.log( this.$store.state.page2, this.$store.state.page)
  },
  components: {},
  methods: {
    GetNameIdnumber(data){
      const filtered = data.flatMap(item => 
        item.all
          .filter(person => person.isshow)
          .map(person => ({ 
            name: person.name, 
            idnumber: person.idnumber 
          }))
      );

      // 步骤2：格式化为"姓名(身份证号)"格式，多个用逗号隔开
      const resultStr = filtered.map(item => {
        // 处理身份证号为空或不存在的情况，显示"无"
        const idStr = item.idnumber || "无";
        return `${item.name}(${idStr})`;
      }).join(',');
      return resultStr
    },
    allLay(lead, xl) {
      if(lead==null){
        return ''
      }
      var all = lead
      if(xl!=null){
         all = lead.concat(xl)
      }
      
      var str = all.join(',')
      return str
    },
    arrayToString(arr){
      if(arr){
        return arr.join(',')
      }else{
        return ''
      }
      
    },
    getRandomColor(item, show) {
      if (show) return '#e86e30'
      else if (item) return 'blue'
    },
    ctsearch() {
      this.casepageSize = 10
      this.casecurrentPage = 1
      this.counselpageSize = 10
      this.counselcurrentPage = 1
      this.search()
    },
    // 搜索
    async search(type) {
      let Params = {
        name: this.formMore.name,
        rows: this.casepageSize,
        page: this.casecurrentPage
      }
      if (Params.name == '') {
        this.$message.warning('请输入原告或被告或顾问')
        return
      }
      if (type == 'counsel') {
        Params = {
          name: this.formMore.name,
          rows: this.counselpageSize,
          page: this.counselcurrentPage
        }
        this.counselSelect(Params)
      } else if (type == 'case') {
        Params = {
          name: this.formMore.name,
          rows: this.casepageSize,
          page: this.casecurrentPage
        }
        this.caseSelect(Params)
      } else if(type=='bankruptcy'){
        Params = {
          name: this.formMore.name,
          rows: this.casepageSize2,
          page: this.casecurrentPage2
        }
        this.bankruptcySelect(Params)
      }else if (type == null || type == '') {
        let Params = {
          name: this.formMore.name,
          rows: this.casepageSize,
          page: this.casecurrentPage,
          issearch: true
        }
        await this.caseSelect(Params)
        await this.bankruptcySelect(Params)
        await this.counselSelect(Params)
      }
    },
    // 案件冲突查询
    async caseSelect(Params) {
      this.loading = true
      await ConflictList(Params)
        .then((res) => {
          this.casetableData = res.data.data
          this.caseTotal = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.$message.error('查询出错')
          this.loading = false
        })
    },
    deWeightThree(arr) {
      let map = new Map()
      for (let item of arr) {
        if (!map.has(item.companyName)) {
          map.set(item.companyName, item)
        }
      }
      return [...map.values()]
    },
    // 顾问冲突查询
    async counselSelect(Params) {
      this.loading = true
      await ConflictCounselList(Params)
        .then((res) => {
          this.loading = false
          this.counseltableData = res.data.data
          // const hahaha = this.deWeightThree(this.counseltableData)

          // console.log('hahah', hahaha)
          this.counselTotal = res.data.total
        })
        .catch(() => {
          this.loading = false
          this.$message.error('查询出错')
        })
    },

 // 破产管理人冲突查询
    async bankruptcySelect(Params) {
      this.loading = true
      await BankruptcyConflictList(Params)
        .then((res) => {
          this.bankruptcytableData = res.data.data
          this.caseTotal2 = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.$message.error('查询出错')
          this.loading = false
        })
    },
    // 分页
    handleSizeChangeCase(val) {
      this.casecurrentPage = 1
      this.casepageSize = val
      this.search('case')
    },
    handleCurrentChangeCase(val) {
      this.$store.commit('setPage', val)
      this.casecurrentPage = val
      this.search('case')
    },

    // 分页
    handleSizeChangeCounsel(val) {
      this.counselcurrentPage = 1
      this.counselpageSize = val
      this.search('counsel')
    },
    handleCurrentChangeCounsel(val) {
      this.$store.commit('setPage1', val)
      this.counselcurrentPage = val
      this.search('counsel')
    },

// 分页
    handleSizeChangeCase2(val) {
      this.casecurrentPage2 = 1
      this.casepageSize = val
      this.search('bankruptcy')
    },
    handleCurrentChangeCase2(val) {
      this.$store.commit('setPage2', val)
      this.casecurrentPage2 = val
      this.search('bankruptcy')
    },
    //查看
    Look(row, type) {
      if (type == 'counsel') {
        var url =
          '/#/home/counsel/allCounsel?companyName=' +
          row.companyName +
          '&&id=' +
          row.id
        let mywin = window.open(url, 'allCounsel')
        mywin.onload = function () {
          mywin.location.reload()
        }
        // this.$router.push({
        //   path: '/home/counsel/allCounsel',
        //   query: {
        //     row: row
        //   }
        // })
      }else if(type=='bankruptcy'){
        var url =
          '/#/home/bankruptcy/bankruptcyManagerInfo?name=' +
          row.name +
          '&&id=' +
          row.id
        let mywin = window.open(url, 'bankruptcy')
        mywin.onload = function () {
          mywin.location.reload()
        }
      } else {
        this.$store.commit('setmenustatus', 1)
        var url =
          '/#/home/case/caseinfo?guid=' +
          row.id +
          '&status=' +
          row.typeId +
          '&caseType=' +
          row.typeId.substring(21, 23)

        var type=row.typeId.substring(21, 23)
        if(type==12){
          url =
          '/#/home/case/bankruptdetail?guid=' +
          row.id +
          '&type=破产' 
        }
          
        // 在新窗口中打开页面
     
        let mywin = window.open(url+'&random=' + Math.random(), '_blank')
       
        mywin.onload = function () {
          mywin.location.reload()
        }
      }
    },

    //日期格式转换
    formatTime(row, column) {
      if (row[column.property] == null||row[column.property] == '') {
        return null
      }
      const date = new Date(row[column.property])
      // return row[column.property].Format('yyyy-MM-dd HH:mm')
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      return (
        year + '-' + month + '-' + day
        // day +
        // ' ' +
        // hours +
        // ':' +
        // minutes +
        // ':' +
        // seconds
      )
    },
    tableRowClass({ row, rowIndex }){
      console.log("isoth",row.isOther)
      if (row.isOther) {
        return 'beig-row';
      }else{
        return '';
      }
      
    }

  }
}
</script>
  
<style lang="less" scoped>
#join {
  // position: relative;
  .search {
    box-sizing: border-box;
    display: flex;
    padding: 24px;
    width: 100%;
    .el-input {
      width: 20%;
    }
    ::v-deep .el-input__inner {
      // width: 80% !important;
      // width: 300px;
      height: 45px;
      background-color: #fafafa;
      border: 0 !important;
    }
    .el-select {
      margin: 0 10px;
      width: 150px;
    }
  }
  .pagination {
    // position: absolute;
    // bottom: 40px;
    // right: 80px;
    margin: 20px 20px;
    display: flex;
    justify-content: space-between;
    .el-pagination {
      padding-right: 50px;
    }
  }
  .sel-input-all {
    width: 70%;
  }

  .select {
    width: 10vw;
    margin-bottom: 1rem;
  }
  .btn {
    width: 100%;
    text-align: center;
  }
  .top {
    width: 100%;
    display: flex;
    color: #3077e6;
    align-items: center;
    font-size: 19px;
    font-weight: 400;
    padding-left: 58px;
    margin-bottom: 32px;
  }
  .icon {
    width: 4px;
    height: 18px;
    background: #3077e6;
    border-radius: 9px;
    margin-right: 5px;
  }
  .litigant-container {
    // text-align: left;
  }
  /deep/.beig-row{
      background: #e6e5e4 !important;
  }
}
</style>
  